import { Link, useSearchParams } from "react-router-dom";
import { AlertCircle, ArrowLeft, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import XeroConnectionTab from "@/components/admin/XeroConnectionTab";

const XERO_ERRORS: Record<string, string> = {
  missing_code: "Xero did not return an authorisation code. Please try again.",
  state_expired: "The connection request expired. Please start again.",
  invalid_state:
    "The connection request could not be verified. Please start again.",
  token_exchange_failed:
    "Xero rejected the authorisation code. Please try again.",
  connections_failed:
    "Connected to Xero, but the organisation list could not be read.",
  vault_write_failed:
    "Xero authorised the connection, but the credentials could not be stored.",
  access_denied: "The Xero authorisation was declined.",
};

const XeroCallback = () => {
  const [params] = useSearchParams();
  const error = params.get("error");
  const connected = params.get("status") === "connected";

  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-5xl p-4 sm:p-6">
        <Button asChild variant="ghost" size="sm" className="mb-4 gap-2">
          <Link to="/datacore/xero">
            <ArrowLeft className="h-4 w-4" />
            Back to Xero
          </Link>
        </Button>

        <h1 className="mb-4 text-xl font-semibold text-foreground">Xero</h1>

        {error && (
          <div className="mb-6 flex items-start gap-2 rounded-lg border border-destructive/40 bg-destructive/5 p-3 text-sm text-destructive">
            <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
            <span>
              {XERO_ERRORS[error] ?? `The Xero connection failed (${error}).`}
            </span>
          </div>
        )}

        {connected && !error && (
          <div className="mb-6 flex items-start gap-2 rounded-lg border border-emerald-600/40 bg-emerald-600/5 p-3 text-sm text-emerald-700 dark:text-emerald-400">
            <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" />
            <span>
              Xero connected. The organisations below are now authorised.
            </span>
          </div>
        )}

        {/* Only the connection state: this page reports a callback outcome, it
            is not a second home for the organisations table or the run console. */}
        <XeroConnectionTab />
      </div>
    </div>
  );
};

export default XeroCallback;
